import * as React from "react";
import { forwardRef } from "react";
const SvgChevronHorizontal = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 6 10", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M.75 9.5 5.25 5 .75.5" }));
const ForwardRef = forwardRef(SvgChevronHorizontal);
export { ForwardRef as ReactComponent };
